import React, { Component } from 'react'
import './quote.css'

class Quote extends Component {
  render () {
    let data = this.props.data;
    return (
      <div style={{textAlign: 'center', fontFamily: "futura-pt-light"}}>
        <div className="quote-mark">
          “
        </div>

        <div className="quote-text">
          {data.text}
        </div>
        <div className="quote-attribution">
          {data.attribution}
        </div>
      </div>
    );
  }
}


export default Quote
